const inspectionProfile = {
  backbtn: "Geh zurück",

  submit: "einreichen",
  newInspection: "Neue Inspektion erstellen",
  details: "Betriebsprüfungprotokoll",
  equipmentTag: "Ausrüstungs-Tag",
  client: "Kunde",
  equipType: "Ausstattungsart",
  company: "Unternehmen",
  createby: "Erstellen nach",
  date: "Datum erstellt",
  coupled: "Kupplunseite",
  free: "Lagerseite",
  preasureBar: "Druck (BAR)",
  preasurePsi: "Druck (PSI)",
  stuffingBox: "Stopfbuchsraum",
  temperature: "Eingangstemperatur",
  pressure: "Druck",
  celsius: "Temperatur (Celsius)",
  fahrenheit: "Temperatur (Fahrenheit)",
  coolingWaterIn: "Kühlwasser",
  coolingWaterOut: "Kühlwasser Ausgangstemperatur",
  pumpHousing: "Pumpengehäuse",
  oilIn: "Öl ein",
  ollOut: "Öl Out",
  level: "Niveau",
  levelmm: "Niveau (mm)",
  levelL: "Niveau (l)",
  refilling: "Nachfüllsystem",
  system: "System",
  instrument: "Instrumentenluft",
  tank: "Panzer",
  cw: "Kühlwasser Eingangstemperatur",
  cin: "Kupplunseite In",
  cout: "Kupplunseite nach außen",
  fin: "Lagerseite In",
  fout: "Lagerseite raus",
  motor: "Motor",
  barrier: "Barrier Flow",
  barrierFlowLmin: "Barrier Flow (L/min)",
  Comment: "Kommentar",
  barrierFlowGalmin: "Barrier Flow(L/min)",
  delete: "Inspektion löschen"
};
export default inspectionProfile;
